import React, { useState } from "react";

// Read-only view of the visible test cases for the current question.
// Hidden test cases are summarized as a count — never shown.
export default function TestCasePanel({ testCases = [], hiddenCount = 0, results = null }) {
  const resultMap = new Map();
  if (Array.isArray(results)) {
    for (const r of results) resultMap.set(r.testCaseId, r);
  }

  if (testCases.length === 0) {
    return (
      <div className="p-4 text-center text-xs text-slate-400">
        No visible test cases.
        {hiddenCount > 0 && <div className="mt-1">+ {hiddenCount} hidden test{hiddenCount === 1 ? "" : "s"}</div>}
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-800">
      {testCases.map((tc, idx) => (
        <TestCaseRow key={tc.id} tc={tc} index={idx} result={resultMap.get(tc.id)} />
      ))}
      {hiddenCount > 0 && (
        <div className="px-3 py-2 text-[11px] text-slate-400 italic">
          + {hiddenCount} hidden test{hiddenCount === 1 ? "" : "s"} (run at submission time)
        </div>
      )}
    </div>
  );
}

function TestCaseRow({ tc, index, result }) {
  const [open, setOpen] = useState(false);
  const statusIcon = result == null ? "○" : result.passed ? "✓" : "✗";
  const statusColor = result == null
    ? "text-slate-500"
    : result.passed
    ? "text-emerald-500"
    : "text-red-500";

  return (
    <div className="text-xs">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2 hover:bg-slate-800/50 text-left"
      >
        <span className={`${statusColor} font-mono`}>{statusIcon}</span>
        <span className="text-slate-300 font-medium">Test {index + 1}</span>
        {tc.description && <span className="text-slate-500 truncate">— {tc.description}</span>}
        {result?.runtimeMs != null && (
          <span className="ml-auto text-[10px] text-slate-500 font-mono">{result.runtimeMs}ms</span>
        )}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2 font-mono text-[11px]">
          <KV label="Input"  value={tc.input} />
          <KV label="Expected" value={tc.expectedOutput} />
          {result && <KV label="Yours" value={result.actualOutput} bad={!result.passed} />}
          {result?.errorMessage && <KV label="Error" value={result.errorMessage} bad />}
        </div>
      )}
    </div>
  );
}

function KV({ label, value, bad = false }) {
  return (
    <div>
      <div className="text-slate-500 mb-0.5">{label}</div>
      <pre className={`whitespace-pre-wrap break-all bg-slate-800 border ${bad ? "border-red-900" : "border-slate-700"} rounded p-2 text-slate-200 max-h-40 overflow-y-auto`}>
        {value == null ? "—" : String(value)}
      </pre>
    </div>
  );
}
